export enum JkJobKind {
  Batch = '批次',
  Report = '報表',
  Api = 'API',
}

export enum JkKMComponentType {
  TJKBTNEDIT = 'TJKBTNEDIT',
  TJKDBEDIT = 'TJKDBEDIT',
  TJKRANGE = 'TJKRANGE',
  TComboBox = 'TCOMBOBOX',
  TjkComboBox = 'TJKCOMBOBOX',
  TjkRange = 'TJKRANGE',
  TjkMultiSelect = 'TJKMULTISELECT',
}


export interface AzureEnvironment {
  tts_key?: string;
  tts_url?: string;
  translate_key?: string;
  AZURE_OPENAI_KEY?: string;
  AZURE_OPENAI_ENDPOINT?: string;
  region?: string;
}

export interface JkEnvironment {
  production: false;
  appName: string;
  title: string;
  appDescript: string;
  appId: string;
  version: string;
  jwtSecret: string;
  sysdbname: string;
  reportUrl: string;
  wsUrl: string;
  baseAttachUrl: string;
  envExpireHour: number;
  configFileName: string;
}

export const JkEnvironmentDefault: JkEnvironment = {
  production: false,
  appName: '',
  title: '',
  appDescript: '',
  appId: '',
  version: '',
  jwtSecret: '',
  sysdbname: '',
  reportUrl: '',
  wsUrl: '',
  baseAttachUrl: '',
  envExpireHour: 36,
  configFileName: ''
}

export interface JkJobOption {
  kind: string; // xStringGrid.Cells[4, i + 1] := mNode1.Attributes['Kind'];  TJKBTNEDIT  TJKDBEDIT TJKRANGE TComboBox
  caption: string; // xStringGrid.Cells[0, i + 1] := mNode1.Attributes['Caption'];
  text: string; // text, xStringGrid.Cells[1, i + 1] := mNode1.text;
  name: string; // xStringGrid.Cells[2, i + 1] := mNode1.NodeName;
  type: string; // TComboBox,TjkComboBox TJKRange : A +"～"+ B
  ps: string; // xStringGrid.Cells[3, i + 1] := mNode1.Attributes['PS'];
  ps2?: string;
}


export const CR = "\r\n";

export interface idNameItem {
  id: string;
  name: string;
  idName?: string;
  nameId?: string;
  icon?: string;
  ps1?: string;
  ps2?: string;
  ps3?: string;
}

export const YNList: idNameItem[] = [{ id: "Y", name: "Y:是" }, { id: "N", name: "N:否" }];
export const YNAllList: idNameItem[] = [{ id: "", name: "全部" }, { id: "Y", name: "Y:是" }, { id: "N", name: "N:否" }];
export const close2List: idNameItem[] = [{ id: "Y", name: "Y:已結案" }, { id: "N", name: "N:未結案" }];
export const close2AllList: idNameItem[] = [{ id: '', name: '全部' }, { id: "Y", name: "Y:已結案" }, { id: "N", name: "N:未結案" }];
export const close3List: idNameItem[] = [{ id: "Y", name: "Y:已結案" }, { id: "N", name: "N:未結案" }, { id: 'y', name: '指定結案' }];
export const close3AllList: idNameItem[] = [{ id: '', name: '全部' }, { id: "Y", name: "Y:已結案" }, { id: "N", name: "N:未結案" }, { id: 'y', name: '指定結案' }];


export interface jkRestReturn {
  result: boolean;
  message: string;
  data: string;
  obj: any;
  request: any;
  rowsAffected: number;
  log: string;
  errorLog: string;
  errorCode: number;
  errorMessage: string;
  //errorLog: string;
  parent: any; // 父 jkRestReturn 也可傳回
  clear(bool?: boolean): void;
  addResult(xLog: string): void;
  getResult(): string;
  addResultError(xLog: string, isLogger?: boolean): string;
  getResultError(): string;
  addResultWarning(xLog: string): string;
  mergeLog(from: jkRestReturn): void;
  ok(): void;
  assign(r: jkRestReturn): void;
}

/**
 * @param prompt prompt: 問題內容。
 * @param n    整數，表示生成的候選項數量。
 * @param max_tokens 一個整數，表示生成的文本的最大令牌數。
 * @param temperature 一個浮點數，表示生成文本的隨機性。值越高，生成的文本就越隨機。
 * @param top_p 一個浮點數，表示只考慮概率最高的一部分候選項，以避免生成不相關的或者無意義的文本。
 * 一個字符串，表示生成文本的終止條件。
 * @param frequency_penalty 一個浮點數，表示鼓勵生成更不常見的文本。
 * @param presence_penalty 一個浮點數，表示鼓勵生成更不常見的文本。
 */
export interface IOpenaiCompletionOption {
  systemPrompt: string; // 我加的.非openai的
  model: string; // "text-davinci-003"
  /** 1 回答的候選項數量。一個整數，表示生成的候選項數量。小心使用勿過量 */
  n: number;
  prompt: string; // "問題內容"
  /** 浮點數,0~2,通常 0.2~0.8 ，表示生成文本的隨機性。值越高，生成的文本就越隨機。 */
  temperature?: number; // 0.3 or 0.6
  /** 整數,default: 16, Most models have a context length of 2048 tokens (except for the newest models, which support 4096) */
  max_tokens?: number; // 100
  /** -2.0 ~ 2.0 預設1  */
  top_p?: number; // 1.0
  /** 是用於評估模型去做生存詞以及否及確定主題語意的參數。它是一種惩罚機制，使得較新出現的詞重要性較低，反之則較高，因而有助於自動生成模型切換主題、生成新詞。 */
  frequency_penalty?: number; // 0.0
  /**
   *-2.0 ~ 2.0. 評分新令牌的積極值是基於它們是否出現在到目前為止的文本中，增加了模型談論新主題的可能性。
   *
   * @type {number}
   */
  presence_penalty?: number; // 0.0,
  user?: string;
}

export interface IopenWin {
  result: boolean;
  mainTable: string;
  item: string;
  type: string;
  title: string;
  sqlSelect: string;
  where: string;
  order: string;
  //orderBy: string;
  PS: string;
  display: string;
  map: string;
  sqlReturn: string;
  valueExpr?: string;
  displayExpr?: string;
  obj: any;
  returnData?: any[];
  // rowsAffected: number;
  message: string;
  clear(): void;
}

export type CreateImageRequestSizeEnum = "256x256" | "512x512" | "1024x1024";
export type CreateImageResponseFormat = "url" | "b64_json";

export interface IOpenaiImageOption {
  prompt: string;
  n: number;
  size?: CreateImageRequestSizeEnum;
  response_format?: CreateImageResponseFormat; // url or b64_json.
  user?: string;
}
/**
 *
 *
 * @interface IOpenaiImageEditOption
 */
export interface IOpenaiImageEditOption {
  /**
   * 圖形編修檔名
   * @type {string}
   */
  image: string;
  mask?: string;
  /**
   * A text description of the desired image(s). The maximum length is 1000 characters.
   * @type {string}
   */
  prompt: string;
  n?: number;
  size?: CreateImageRequestSizeEnum;
  response_format?: CreateImageResponseFormat; // url or b64_json.
  user?: string;
}

export interface IOpenaiImageVariationOption {
  image: string;
  n?: number;
  size?: CreateImageRequestSizeEnum;
  response_format?: CreateImageResponseFormat; // url or b64_json.
  user?: string;
}
// audio
export interface IOpenaiTranscriptionOption { // 將音頻轉譯為其它語言。
  file: string;  // mp3, mp4, mpeg, mpga, m4a, wav, or webm.
  model: string; // 'whisper-1'
  prompt?: string; // 可選文本，用於指導模型的風格或繼續之前的音頻片段。 提示應與音頻語言一樣。
  response_format?: string; //  json, text, srt, verbose_json, or vtt.
  user?: string;
  temperature?: number; // 0 0~1
  language?: string; // en,zh...

}
export interface IOpenaiTranslationOption {
  file: string;
  model: string; // 'whisper-1'
  prompt?: string; // 可選文本，用於指導模型的風格或繼續之前的音頻片段。 提示應為英文。
  response_format?: string; //  json, text, srt, verbose_json, or vtt.
  user?: string;
  temperature?: number; // 0 0~1
}

export interface IGoogleTranslateOption {
  text: string;
  // location: string,  golbal
  sourceLanguageCode: string,
  targetLanguageCode: string
}

export interface keyValue2SqlWhereOption {
  params: any[],
  where: string,
  keyFieldList: any[]
};

export interface kbar {
  open: number;
  high: number;
  low: number;
  close: number;
  volume: number;
  date: Date;
  dir: number; // 0:平/黑K 1:漲/紅K -1:跌/綠K
  assign(open: number, high: number, low: number, close: number, volume: number, date: Date): void;
}

export enum UiModeType {
  dialog = 'dialog',
  tab = 'tab',// 20260208 作廢.都用dialog
  //page = 'page',
  //popup = 'popup',
  //none = 'none',
}
/*
export enum PageType { // base | detail | master | report | query | batch | dialog
  'base',
  'data',//建檔
  'bill',
  'report',
  'query',
  'batch',
  'dialog',
}*/

export enum PageKind {
  'bill', 'master', 'detail', 'body', 'foot', 'hand', 'report', 'query', 'batch', 'dialog', 'base'
}

export const uiModeList: idNameItem[] = [
  { id: 'dialog', name: 'dialog' },
  { id: 'tab', name: 'tab' },
  //{ id: 'page', name: 'page' },
  //{ id: 'popup', name: 'popup' },
  //{ id: 'none', name: 'none' },
];

export interface OpenWinLoadOption {
  mainTable: string;
  item: string;
  type: string;
  where?: string;
  order?: string;
  params: any[];
  host?: string;
  token?: string;
  list: any[];
}

export interface JkOpenwinParams {
  isModal: boolean;
  maintable: string,
  item: string,
  params: any[],
  isMultiSelect: boolean,
  filterVisible: boolean,
  valueExpr: string,
  displayExpr: string,
  returnData: any[]
};

